import styled from 'styled-components';

export const NotDTCStepPhoneContent = styled.div`
  > p:first-child {
    font-family: inherit;
    margin-top: 10px;
    color: #656a66;
    margin-bottom: 24px;
  }
  .react-tel-input {
    input {
      border: none !important;
      background-color: transparent !important;
      border-bottom: 1px solid #cac8b0 !important;
      font-size: 20px !important;
      line-height: 24px !important;
      padding: 0px 0px 8px !important;
      border-radius: 0 !important;
      width: 300px !important;
      padding-left: 50px !important;
      ::placeholder {
        color: #cac8b0;
      }
    }
    .flag-dropdown {
      background: transparent;
      border: none;
    }
    .flag {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .react-tel-input .selected-flag:hover,
  .react-tel-input .selected-flag:focus {
    background-color: transparent;
  }
`;
